import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousRestoration;
    };
  }, []);

  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      if (hash) {
        let id = hash.slice(1);

        try {
          id = decodeURIComponent(id);
        } catch {
          // Use the original fragment if it cannot be decoded.
        }

        const section = document.getElementById(id);

        if (section) {
          section.scrollIntoView({
            behavior: "instant",
            block: "start",
          });
          return;
        }
      }

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
